import { languages } from "../../../dummyData/dummyData";
import { Routes } from "../../../routes";
import { generatePath, useHistory } from "react-router-dom";
import TileItem from "../TileItem/TileItem";
import TileItemInfo from "../../molecules/TileItemInfo/TileItemInfo";
import VerificationBar from "../../molecules/VerificationBar/VerificationBar";
import { PROGRESS_BAR_SETTINGS } from "../CourseAuditsList/CourseAuditsList";
import { dateFormat } from "../../../utils/formatters";

const CourseAuditItemTile = ({ data }) => {
  const { created, user, document_audit, referenceAuditText, revision_summary, actionRequiredText, dateText, status, statusText, version, actionsSummaryText, buttons } = data;

  let history = useHistory();

  return (
    <TileItem
      title={dateFormat(created)}
      subtitle={`${languages.EN.labels.by} ${user.profile.name} ${user.profile.surname}`}
      image={user.profile.profile_image_small}
      bar={(
        <VerificationBar
          text={statusText.toUpperCase()}
          progress={PROGRESS_BAR_SETTINGS[status].progress}
          variant={PROGRESS_BAR_SETTINGS[status].variant}
          inTile={true}
        />
      )}
      buttons={buttons}
    >
      <TileItemInfo header={languages.EN.labels.relatedReferenceAudit} value={referenceAuditText} fullRow={true} button={referenceAuditText ? {
        icon: "dots",
        onClick: () => history.push(generatePath(Routes.referenceAudit.relatedCourses.base, {
          reference: document_audit.previous_version.id,
          audit: document_audit.id
        })),
        tooltip: languages.EN.labels.details,
      } : null} />
      <TileItemInfo header={languages.EN.labels.revisionSummary} value={revision_summary} fullRow={true} />
      <TileItemInfo header={languages.EN.labels.deadlineDate} value={dateText} />
      <TileItemInfo header={languages.EN.labels.actionRequired} value={actionRequiredText} />
      <TileItemInfo header={languages.EN.labels.actionsSummary} value={actionsSummaryText} fullRow={true} button={version !== null ? {
        icon: "dots",
        onClick: () => window.open(generatePath(Routes.courseEdit.conspect.base, {
          id: version.id,
        })),
        tooltip: languages.EN.labels.details,
      } : null} />
    </TileItem>
  );
};

export default CourseAuditItemTile;
